import React from "react"
import DeleteFilter from "../../../../assets/iconos/close.svg";
import { latest as API_URL } from "../../../../config/api";
import { topProducer } from "../widgets/Charts";
import Helpers, { windowsActive,number_format } from "../../../../config/Helpers";
import ReactEcharts from "echarts-for-react";

class TopProducers extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            top_segment_table : "",
            top_segment_totals : "",
            top_agency_table : "",
            top_agency_totals : "",
        }
    }

    getOptionTypeBar = (chart) => {
        let self = this;
        let char_keys = Object.keys(this.props.response_request);
        let data = {};
        if (char_keys.length > 0){
            data = this.props.response_request.top_producer.charts[chart]
        }
        return topProducer(data);
    }

    componentWillReceiveProps(props){
        let self = this;
        let char_keys = Object.keys(props.response_request);
        if (char_keys.length > 0){
            const data = props.response_request.top_producer;
            let sgm = data.tables.segment;
            let agency = data.tables.agency;
            let totals = data.tables.totals;
            this.state.top_segment_table = Object.keys(sgm).map((key, index) => 
                <div key={"list-current-year-production-"+index} className={"column-grid " + (index % 2 ? "row-c " : "")}>
                    <span className="row-grid name">{sgm[key].segment.name}</span>
                    <span className="row-grid rn">{number_format(sgm[key].room_nights,0)}</span>
                    <span className="row-grid adr">${number_format(sgm[key].adr,2)}</span>
                    <span className="row-grid rev">${number_format(sgm[key].revenue,2)}</span>
                </div>
            )
            this.state.top_agency_table = Object.keys(agency).map((key, index) => 
                <div key={"list-current-year-production-"+index} className={"column-grid " + (index % 2 ? "row-c " : "")}>
                    <span className="row-grid name">{agency[key].agency.name}</span>
                    <span className="row-grid rn">{number_format(agency[key].room_nights,0)}</span>
                    <span className="row-grid adr">${number_format(agency[key].adr,2)}</span>
                    <span className="row-grid rev">${number_format(agency[key].revenue,2)}</span>
                </div>
            )
            this.state.top_segment_totals = (
                <div className={"column-grid totals"}>
                    <span className="row-grid name"></span>
                    <span className="row-grid rn">{number_format(totals.total_rns_sgm, 0)}</span>
                    <span className="row-grid adr">${number_format(totals.total_adr_sgm,2)}</span>
                    <span className="row-grid rev">${number_format(totals.total_rev_sgm,2)}</span>
                </div>
            )
            this.state.top_agency_totals = (
                <div className={"column-grid totals"}>
                    <span className="row-grid name"></span>
                    <span className="row-grid rn">{number_format(totals.total_rns_agency,0)}</span>
                    <span className="row-grid adr">${number_format(totals.total_adr_agency,2)}</span>
                    <span className="row-grid rev">${number_format(totals.total_rev_agency,2)}</span>
                </div>
            )
        }
    }

    render() {
        return (
            <section>
                <div className="row">
                    <div className={"datagrid-widget col-md-6 top-producer"}>
                        <div className="container-fluid">
                            <div className="row header-widget">
                                <div className="col-md-12 options-widget">
                                    <span className="title">TOP PRODUCERS SEGMENTS</span>
                                    
                                    <span className="opt remove-widget hide">
                                        <img src={DeleteFilter} />
                                    </span>
                                </div>
                            </div>
                            <div className="current-values">
                                <div className="row">
                                    
                                </div>
                                <div className="row">
                                    <div className="col-md-12 datagrid-list">
                                        <ReactEcharts
                                            option={windowsActive(this.props, "reservation", "top-producer") === true ? this.getOptionTypeBar("segment") : {} }
                                            notMerge={true}
                                            lazyUpdate={true}
                                            theme={"theme_name"}
                                            onChartReady={this.onChartReadyCallback}
                                        />
                                    </div>
                                </div>
                            </div>   
                        </div>
                    </div>
                    <div className={"datagrid-widget col-md-6 top-producer"}>
                        <div className="container-fluid">
                            <div className="row header-widget">
                                <div className="col-md-12 options-widget">
                                    <span className="title">TOP PRODUCERS AGENCY</span>
                                    
                                    <span className="opt remove-widget hide">
                                        <img src={DeleteFilter} />
                                    </span>
                                </div>
                            </div>
                            <div className="current-values">
                                <div className="row">
                                    
                                </div>
                                <div className="row">
                                    <div className="col-md-12 datagrid-list">
                                        <ReactEcharts
                                            option={windowsActive(this.props, "reservation", "top-producer") === true ? this.getOptionTypeBar("agency") : {} }
                                            notMerge={true}
                                            lazyUpdate={true}
                                            theme={"theme_name"}
                                            onChartReady={this.onChartReadyCallback}
                                        />
                                    </div>
                                </div>
                            </div>   
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className={"datagrid-widget col-md-6 top-producer"}>
                        <div className="container-fluid">
                            <div className="row header-widget">
                                <div className="col-md-12 options-widget">
                                    <span className="title">TOP SEGMENTS</span>
                                    
                                    <span className="opt remove-widget hide">
                                        <img src={DeleteFilter} />
                                    </span>
                                </div>
                            </div>
                            <div className="row current-values">
                                <div className="col-md-12 head-current">
                                    <span className="row-grid name">NAME</span>
                                    <span className="row-grid rn">R/N</span>
                                    <span className="row-grid adr">ADR</span>
                                    <span className="row-grid rev">REV</span>
                                </div>
                                <div className="col-md-12 datagrid-list scroll-table">
                                    {this.state.top_segment_table}
                                </div>
                                <div className="col-md-12 datagrid-list">
                                    {this.state.top_segment_totals}
                                </div>
                            </div>   
                        </div>
                    </div>
                    <div className={"datagrid-widget col-md-6 top-producer"}>
                        <div className="container-fluid">
                            <div className="row header-widget">
                                <div className="col-md-12 options-widget">
                                    <span className="title">TOP AGENCIAS</span>
                                    
                                    <span className="opt remove-widget hide">
                                        <img src={DeleteFilter} />
                                    </span>
                                </div>
                            </div>
                            <div className="row current-values">
                                <div className="col-md-12 head-current">
                                    <span className="row-grid name">NAME</span>
                                    <span className="row-grid rn">R/N</span>
                                    <span className="row-grid adr">ADR</span>
                                    <span className="row-grid rev">REV</span>
                                </div>
                                <div className="col-md-12 datagrid-list scroll-table">
                                    {this.state.top_agency_table}
                                </div>
                                <div className="col-md-12 datagrid-list">
                                    {this.state.top_agency_totals}
                                </div>
                            </div>   
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default TopProducers



// WEBPACK FOOTER //
// ./src/Frontend/modules/marketing/reservations/views/TopProducers.js